<template>
  <div />
</template>
<script setup lang="ts">
  import router from '@/router';
  import { useStore } from 'vuex';

  const store = useStore();

  const initialize = async () => {
    const homePath = store.getters['auth/auth'].homePath as string | undefined;
    if (homePath) return router.push(homePath);
    router.push('/master');
  };
  initialize();
</script>
